/* QrCode — data:image/svg+xml <img>. Sizing is driven entirely by the
 * `width`/`height` HTML attributes (a runtime `size` prop, not a fixed
 * token bucket), so this stylesheet only resets the default inline-image
 * baseline gap. No color/background rules: the generated SVG paints its
 * own white module background + black modules, independent of the page's
 * light/dark theme, which is required for the quiet zone + contrast a
 * camera scan depends on. */

.qrCode {
  display: block;
}
